import React from 'react';
import { useTranslation } from 'react-i18next';

import { JobResourceLinks } from '@/console/features/jobs/components/job-resource-links/job-resource-links';
import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { ProjectsIcon } from '@/shared/assets/icons/projects-icon';
import { useReadProjectsByIdsQuery } from '@/shared/redux/api/assets/projects/projects-api';
import { isPermissionDeniedError } from '@/shared/redux/api/utils/error-handlers';

export const JobProject: React.FC<TJobRenderComponentProps> = ({
  job,
  truncate,
}) => {
  const { t } = useTranslation();
  const projectIds = job?.projectIds;

  const { data, error, isLoading, isFetching } = useReadProjectsByIdsQuery(
    { projectIds: projectIds! },
    { skip: !projectIds?.length },
  );

  const namesById = Object.fromEntries(
    data?.readProjectsByIds?.items?.map((project) => [
      project.projectId,
      project.name,
    ]) ?? [],
  );

  return (
    <JobResourceLinks
      ids={projectIds}
      namesById={namesById}
      isPending={isLoading || isFetching}
      isProtected={Boolean(data) || isPermissionDeniedError(error)}
      resourceType="project"
      deletedLabel={t('projects:deleted_project')}
      icon={ProjectsIcon}
      getPath={(projectId) => `/projects/${projectId}`}
      truncate={truncate}
    />
  );
};
